import axiosInstance from '../../../../../services/axios/axios';
import { then } from '../../../../../services/axios/_utility';

/**
 * Asynchronously retrieves hospitals list
 *
 * @function
 * @returns {object[]} array of key-value-pairs of hospitals.
 */
export const getHospitals = () => {
    return axiosInstance
        .get(
            `api/Components/Dropdown/HOSPITALS`
        )
        .then(response => {
            return then(response, payload => payload);
        })
        .catch(error => {
            throw error;
        });
};
